/** Pure canonical policy: distinct portfolio homepages keep their own origin;
 * shared catalog/editorial pages point to the primary storefront. */
import { isPortfolioDomain, normalizedPortfolioHost } from './portfolioDomains';

export const CANONICAL_DOMAIN = process.env.CANONICAL_DOMAIN || 'smartblindspro.com';

/** Entity name used in schema for every consolidated brand (the primary's). */
export const PRIMARY_ENTITY_NAME = 'Smart Blinds Pro';

const INDEPENDENT = new Set(
  (process.env.INDEPENDENT_DOMAINS || '')
    .split(',')
    .map((d) => d.trim())
    .filter(Boolean)
);

export function canonicalSiteUrlForDomain(domain: string, pathname = '/'): string {
  const d = normalizedPortfolioHost(domain);
  if (!d) return `https://${CANONICAL_DOMAIN}`;
  if (d === 'localhost' || d.startsWith('localhost:')) return `http://${d}`;
  if (isPortfolioDomain(d)) return pathname === '/' ? `https://${d}` : `https://${CANONICAL_DOMAIN}`;
  if (INDEPENDENT.has(d)) return `https://${d}`;
  return `https://${CANONICAL_DOMAIN}`;
}
